module.exports = __webpack_public_path__ + "img/mail.510f8d44.svg";